import React, { useState, useEffect } from "react";
import style from "./AddPracticeLogo.module.css";

function AddPracticeLogo(props) {
  const [inputList, setInputList] = useState([]);
  const [inputImage, setInputImage] = useState("");
  // const [max_upload, setMaxUpload] = useState("");
  const [imageErr, setImageError] = useState("");

  useEffect(
    () => {
      if (
        props.propsState.editLogo &&
        props.propsState.editLogo.length !== 0
      ) {
        const list = props.propsState.editLogo.map((item) => ({
          attachment_id: item.attachment_id,
          isNewUpload: false,
          delete: false,
          selectedFile: "",
          preview: item.attachment_url,
        }));
        setInputList(list);
      }

      // setMaxUpload(max_upload);
    },
    [props.propsState.editLogo]
  );

  // handle input change
  const handleInputChange = (event, index) => {
    const { name, files } = event.target;
    if (files && files[0]) {
      let FileSize = files && files[0].size / 1024 / 1024; // in MB
      if (/\.(jpe?g|png|svg)$/i.test(files && files[0].name) === false) {
        setImageError("Not an image");
      } else {
        if (FileSize > 2.0) {
          setImageError("Please upload file less than 2MB!");
        } else {
          setImageError("");
          let reader = new FileReader();
          reader.onload = (e) => {
            var image = new Image();
            //Set the Base64 string return from FileReader as source.
            image.src = e.target.result;
            //Validate the File Height and Width.
            image.onload = function () {
              let height = this.height;
              console.log("height", height)
              //let width = this.width;
              if (height < 90 || height > 150) {
                setImageError("Height of the logo image must range between 90px to 150px.");
                return false;
              }else{
                  setImageError("");
                  setInputImage({ inputImage: e.target.result });
                  const list = [...inputList];
                  //const list = [];
                  list.push({
                    selectedFile: files[0],
                    preview: e.target.result,
                    isNewUpload: true,
                    attachment_id: "",
                    delete: false,
                  });
                  //console.log("list", list)
                  setInputList([...list]);
                  props.getPicData([...list]);
              }
            };
          };
          reader.readAsDataURL(event.target.files[0]);
        }
      }
    }
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    //if (list[index].isNewUpload) {
    list.splice(index, 1);
    // } else {
    //   list[index].delete = true;
    // }
    setInputList(list);
    // const newListArr = list.filter((ele, index) => {
    //   return ele.selectedFile !== "";
    // });
    props.getPicData(list);
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([...inputList, { selectedFile: "" }]);
  };

  // upload only image validation

  return (
    <div>
      {inputList && inputList.length === 0 && (
        <div className="row">
          <div className="col">
            <div className="form-group">
              <div className={style.uploadBtnWrapper}>
                <button type="button" className={style.uploadBtn}>
                  <i className="fa fa-upload mr-2" aria-hidden="true"></i>{" "}
                  Upload
                  <input
                    type="file"
                    name="selectedFile"
                    multiple={true}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                    title=""
                  />
                </button>

              </div>
              <span className="error ml-3">{imageErr ? imageErr : ""}</span>
            </div>
          </div>
        </div>
      )}

      <div className={style.imageContainer}>
        {inputList.map((x, i) => {
          return (
            <div key={i} className={`demo ${style.box}`}>
              <div className="row">
                <div className="col-lg-12">
                  <div className={style.imageWidth}>
                    <div className={`form-group ${style.uploadedText}`}>
                      <div className={style.imageWrapper}>
                        <img height={"100%"} width={"100%"} src={x.preview} alt={x.selectedFile.name} />
                      </div>
                      <i
                        className={`fa fa-times ${style.deleteIcon}`}
                        aria-hidden="true"
                        onClick={() => handleRemoveClick(i)}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {/* <div style={{ marginTop: 20 }}>{JSON.stringify(inputList)}</div> */}
    </div>
  );
}

export default AddPracticeLogo;
